// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"beb_a bht_cw bht_jx bht_jo bht_rh bht_vf"};